import { isFetchError } from "@lib/api-fetcher";
import createApiService, { TServiceReturns } from "@lib/create-api-service";
import { API_ROUTES } from "@utils/constants";

import validatePickupTimeFramesResponse from "../models/pickupTimeFrames";
import type { TPickupTimeFrame } from "../types";
import mapPickupTimeFramesResponse from "../utils/mapPickupTimeFramesResponse";

type TPickupTimeFramesParams = {
  countryFrom: string;
  senderZipCode: string;
  isLabelPrintByCourier?: boolean;
};

const pickupTimeFramesService = createApiService({
  url: API_ROUTES.PICKUP_TIMEFRAMES,
  method: "GET",
  allowedErrStatus: 400,
});

const loadPickupTimeFrames = async ({
  countryFrom,
  senderZipCode,
  isLabelPrintByCourier,
}: TPickupTimeFramesParams): Promise<TServiceReturns<TPickupTimeFrame[], unknown>> => {
  try {
    const params = {
      country: countryFrom,
      zip: senderZipCode,
      ...(isLabelPrintByCourier && { additionalServices: ["courier_brings_label_additional_service"] }),
    };
    const response = await pickupTimeFramesService({ params });

    if (!response.isSuccess) {
      // 400 error is normal case when incorrect zip code is provided
      if (isFetchError(response.error) && response.error.response?.status === 400) {
        return { isSuccess: true, data: [] };
      }
      throw new Error(response.error?.message);
    }

    const pickupTimeFramesResponse = validatePickupTimeFramesResponse(response.data);
    const pickupTimeFrames = mapPickupTimeFramesResponse(pickupTimeFramesResponse);

    return { isSuccess: true, data: pickupTimeFrames };
  } catch (err) {
    console.error(err);
    return { isSuccess: false };
  }
};
export default loadPickupTimeFrames;
